import { getIsoWeekAndYear } from "@/utils/isoWeek";

/** Kalite kriterleri — TL ses kaydı + özet (evet/hayır) */
export const TL_QUALITY_YESNO_COLUMNS = [
  { key: "ordeleme", label: "İrdeleme", type: "approval" },
  { key: "mr_isteme", label: "MR İsteme", type: "approval" },
  { key: "mr_tepinme", label: "MR Üstünde Tepinme", type: "approval" },
  { key: "tedirginlik", label: "Tedirginlik", type: "approval" },
  { key: "uzmanlik", label: "Uzmanlık", type: "approval" },
];

export const TL_TABLE_COLUMNS = [
  { key: "assistant_name", label: "Asistan İsmi" },
  { key: "week_number", label: "Hafta" },
  { key: "report_date", label: "Tarih", type: "date" },
  { key: "assistant_report", label: "Asistan Ses Kaydı Raporu", type: "text" },
  { key: "ask_onay", label: "ASK Onayı", type: "approval" },
  ...TL_QUALITY_YESNO_COLUMNS,
  { key: "leader_report", label: "Tk Lideri Ses Kaydı Raporu", type: "text" },
  { key: "tksk_onay", label: "TKSK Onayı", type: "approval", defaultEmpty: true },
  { key: "call1_recording_url", label: "1. Görüşme Ses kaydı", type: "url" },
  { key: "call2_recording_url", label: "2. Görüşme Ses kaydı", type: "url" },
  { key: "sample1_recording_url", label: "Örnek 1. Ses kaydı linki", type: "url" },
  { key: "sample2_recording_url", label: "Örnek 2. Ses kaydı linki", type: "url" },
];

/** Excel dışa aktarma — tablo ile aynı sütunlar */
export const TL_EXCEL_COLUMNS = TL_TABLE_COLUMNS;

export const formatOnayLabel = (value) => {
  const v = String(value || "").toLowerCase();
  if (v === "evet") return "Evet";
  if (v === "hayir" || v === "hayır") return "Hayır";
  return "";
};

export const recordingFilenameFromUrl = (url, fallback = "recording.m4a") => {
  try {
    const name = new URL(String(url)).pathname.split("/").pop();
    return name ? decodeURIComponent(name) : fallback;
  } catch {
    return fallback;
  }
};

export const sanitizeExcelSheetName = (name) => {
  const cleaned = String(name || "Sayfa")
    .replace(/[\\/*?:[\]]/g, " ")
    .trim()
    .slice(0, 31);
  return cleaned || "Sayfa";
};

export const buildExcelRows = (items) => {
  const headerRow = TL_EXCEL_COLUMNS.map((col) => col.label);
  const dataRows = (items || []).map((row) => TL_EXCEL_COLUMNS.map((col) => {
    const value = row?.[col.key];
    if (col.type === "date") {
      return value ? String(value).slice(0, 10) : "";
    }
    if (col.type === "approval") {
      return formatOnayLabel(value);
    }
    if (value === null || value === undefined) return "";
    return value;
  }));
  return [headerRow, ...dataRows];
};

export const TL_RECORDING_FIELDS = [
  { key: "assistant_name", label: "Asistan İsmi", required: true },
  { key: "week_number", label: "Hafta", type: "number" },
  { key: "career_link", label: "Kariyer Link" },
  { key: "report_date", label: "Tarih", type: "date", required: true },
  { key: "assistant_report", label: "Asistan Ses Kaydı Raporu", type: "textarea" },
  { key: "leader_report", label: "Tk Lideri Ses Kaydı Raporu", type: "textarea" },
  { key: "call1_recording_url", label: "1. Görüşme Ses kaydı", type: "recording" },
  { key: "call2_recording_url", label: "2. Görüşme Ses kaydı", type: "recording" },
  { key: "sample1_recording_url", label: "Örnek 1. Ses kaydı linki", type: "recording" },
  { key: "sample2_recording_url", label: "Örnek 2. Ses kaydı linki", type: "recording" },
];

export const EMPTY_TL_RECORDING_FORM = {
  assistant_name: "",
  agent_id: "",
  week_number: "",
  career_link: "",
  report_date: "",
  assistant_report: "",
  leader_report: "",
  ask_onay: "",
  tksk_onay: "",
  call1_recording_url: "",
  call2_recording_url: "",
  sample1_recording_url: "",
  sample2_recording_url: "",
};

export const createDraftRow = (defaults = {}) => ({
  _draftId: `draft-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  ...EMPTY_TL_RECORDING_FORM,
  ...defaults,
});

export const agentsForSearchSelect = (agents = []) => (agents || []).map((a) => ({
  id: a.id,
  ad_soyad: a.ad_soyad || a.name || "",
  kullanici_adi: a.kullanici_adi || "",
  gsm: a.gsm || "",
}));

export const resolveLastWeekNumber = (draftRows = [], items = []) => {
  if (draftRows.length > 0) {
    const w = draftRows[draftRows.length - 1]?.week_number;
    if (w !== null && w !== undefined && w !== "") return w;
  }
  if (items.length > 0) {
    const w = items[0]?.week_number;
    if (w !== null && w !== undefined && w !== "") return w;
  }
  for (const row of items) {
    if (row?.week_number !== null && row?.week_number !== undefined && row?.week_number !== "") {
      return row.week_number;
    }
  }
  return getIsoWeekAndYear(new Date()).week;
};

export const formRowToPayload = (row) => ({
  assistant_name: String(row?.assistant_name || "").trim(),
  agent_id: row?.agent_id ? Number(row.agent_id) : null,
  week_number: row?.week_number === "" || row?.week_number == null ? null : Number(row.week_number),
  career_link: row?.career_link || null,
  report_date: row?.report_date || null,
  assistant_report: row?.assistant_report || null,
  leader_report: row?.leader_report || null,
  call1_recording_url: row?.call1_recording_url || null,
  call2_recording_url: row?.call2_recording_url || null,
  sample1_recording_url: row?.sample1_recording_url || null,
  sample2_recording_url: row?.sample2_recording_url || null,
});

export const mapItemToForm = (item) => ({
  assistant_name: item?.assistant_name || "",
  agent_id: item?.agent_id ? String(item.agent_id) : "",
  week_number: item?.week_number ?? "",
  career_link: item?.career_link || "",
  report_date: item?.report_date || "",
  assistant_report: item?.assistant_report || "",
  leader_report: item?.leader_report || "",
  ask_onay: item?.ask_onay || "",
  tksk_onay: item?.tksk_onay || "",
  call1_recording_url: item?.call1_recording_url || "",
  call2_recording_url: item?.call2_recording_url || "",
  sample1_recording_url: item?.sample1_recording_url || "",
  sample2_recording_url: item?.sample2_recording_url || "",
});

const formatReportDatePart = (value) => {
  const str = String(value ?? "").trim();
  if (!str) return "";
  const iso = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}.${iso[2]}.${iso[1]}`;
  try {
    const d = new Date(str.replace(" ", "T"));
    if (!Number.isNaN(d.getTime())) {
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      return `${dd}.${mm}.${d.getFullYear()}`;
    }
  } catch {
    /* ignore */
  }
  return str;
};

/** Rapor ekranları — tek tarih veya "YYYY-MM-DD - YYYY-MM-DD" aralığı → 28.09.2026 */
export const formatReportDate = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  const str = String(value).trim();
  if (str.includes(" - ")) {
    const parts = str.split(" - ").map((p) => formatReportDatePart(p.trim()));
    if (parts.every((p) => p)) return parts.join(" - ");
  }
  const formatted = formatReportDatePart(str);
  return formatted || "—";
};

export const truncateReportText = (value, max = 80) => {
  const text = String(value || "").trim();
  if (!text) return "";
  if (text.length <= max) return text;
  return `${text.slice(0, max).trim()}…`;
};

export const hasReportText = (row) => Boolean(
  row?.assistant_report?.trim()
  || row?.leader_report?.trim(),
);

/** Liste filtresi: hafta (week_number) ve tarih aralığı birbirinden ayrı */
export const REPORT_LIST_FILTER_ALL = "all";
export const REPORT_LIST_FILTER_WEEK = "week";
export const REPORT_LIST_FILTER_DATE = "date";

export const buildReportListWeekDateParams = ({
  filterMode = REPORT_LIST_FILTER_ALL,
  filterWeek = "",
  startDate = "",
  endDate = "",
} = {}) => {
  const params = {};
  if (filterMode === REPORT_LIST_FILTER_WEEK && filterWeek !== "" && filterWeek != null) {
    const w = Number(filterWeek);
    if (Number.isFinite(w) && w >= 1) params.week_number = w;
  } else if (filterMode === REPORT_LIST_FILTER_DATE) {
    if (startDate) params.start_date = String(startDate).slice(0, 10);
    if (endDate) params.end_date = String(endDate).slice(0, 10);
  }
  return params;
};
